<!--
 * @Description: 展示工商信息
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-16 11:13:15
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2024-04-24 17:08:39
-->
<template>
  <div class="business-information-com">
    <jw-modal :visible="visible" @cancel="correlationClose" :footer="false" :class="['message-modal', !list.id ? 'message-modal-default' : '']" :mask-closable="false">
      <template #title v-if="list.id">
        <div class="message-title">
          <p class="company-content mb-10">
            <jw-link class="company-name" :href="`https://www.tianyancha.com/company/${list?.qccId}`" target="_blank">{{ list.name }}</jw-link>
            <jw-tag :color="list.regStatus == '存续' ? 'green' : 'red'" bordered size="small">{{ list.regStatus ? list.regStatus : '-' }}</jw-tag>
          </p>
          <p>
            <span class="legal-person-name">
              <span style="color: #86909c">{{ $t('法人') }}：</span>{{ list.legalPersonName ? list.legalPersonName : '-' }}
            </span>
            <span>
              <span style="color: #86909c">{{ $t('成立日期') }}：</span>{{ list.estiblishTime ? list.estiblishTime : '-' }}</span
            >
          </p>
        </div>
      </template>

      <template v-if="list.id">
        <jw-card :title="$t('工商信息')" :bordered="false" class="meassage-title">
          <div class="mb-10">
            <span>
              <span class="message-with">{{ $t('注册号') }}：</span>{{ list.regNumber ? list.regNumber : '-' }}</span
            >
          </div>
          <div class="mb-10">
            <span class="message-with">{{ $t('统一社会信用代码') }}：</span>{{ list.creditCode ? list.creditCode : '-' }}
          </div>
          <div class="mb-10">
            <span>
              <span class="message-with">{{ $t('注册资金') }}：</span>{{ list.regCapital ? list.regCapital : '-' }}</span
            >
          </div>
          <div class="mb-10">
            <span>
              <span class="message-with">{{ $t('组织机构代码') }}：</span>{{ list.orgNumber ? list.orgNumber : '-' }}</span
            >
          </div>
          <div class="mb-10">
            <span>
              <span class="message-with">{{ $t('机构类型') }}：</span>{{ list.companyType ? list.companyType : '-' }}</span
            >
          </div>
          <div class="mb-10">
            <span>
              <span class="message-with">{{ $t('省份') }}：</span>{{ list.base ? list.base : '-' }}</span
            >
          </div>
        </jw-card></template
      >
      <template v-else>
        <jw-empty class="eltimeline" :img-src="imgSvg"> {{ $t('暂无数据') }} </jw-empty>
      </template>
    </jw-modal>
  </div>
</template>
<script>
import { reactive, toRefs } from 'vue';
import { clientService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import imgSvg from '@/assets/images/img-no-record.svg';
import { useI18n } from 'vue-i18n';
export default {
  name: 'XlBusinessInformation',
  setup() {
    const { t } = useI18n();
    const data = reactive({
      visible: false,
      list: {}
    });
    // 查询客户天眼查信息
    const getQccInfo = async (customId) => {
      data.list = {};
      data.loading = true;
      const params = {
        id: customId
      };
      try {
        const json = await clientService.qccInfo(params);
        data.loading = false;
        if (!json.error) {
          console.log(json);
          if (json.result) {
            data.list = json.result;
            companyTypeSwitch(data.list.companyType);
          }
        } else {
          Message.error(json.error?.msg || t('操作失败'));
        }
      } catch (e) {
        console.log(e);
        data.loading = false;
        Message.error(e.message || e.statusText || t('操作失败'));
      }
    };
    //关闭
    const correlationClose = () => {
      data.visible = false;
    };
    //打开弹窗
    const messageShow = async (customId, qccInfo = null) => {
      if (qccInfo === null) {
        await getQccInfo(customId);
      } else {
        data.list = qccInfo;
        companyTypeSwitch(data.list.companyType);
      }
      data.visible = true;
    };
    //公司类型
    const companyTypeSwitch = (type) => {
      switch (type) {
        case 1:
          data.list.companyType = t('公司');
          break;
        case 2:
          data.list.companyType = t('香港公司');
          break;
        case 3:
          data.list.companyType = t('社区组织');
          break;
        case 4:
          data.list.companyType = t('律所');
          break;
        case 5:
          data.list.companyType = t('事业单位');
          break;
        case 6:
          data.list.companyType = t('基金会');
          break;
        case 9:
          data.list.companyType = t('新机构');
          break;
        default:
          data.list.companyType = '-';
      }
    };

    return {
      correlationClose,
      messageShow,
      imgSvg,
      companyTypeSwitch,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './xl-business-message.less';
</style>
<style lang="less">
.message-modal {
  .arco-modal-header {
    height: 80px;
    // margin-top: 10px;
  }

  .arco-modal-body {
    padding: 0;
  }

  .arco-modal-header .arco-modal-title-align-center {
    justify-content: flex-start;
  }

  .arco-card-header {
    height: 40px !important;
    background: var(--color-neutral-2);
  }

  .arco-modal-close-btn {
    position: absolute;
    top: 5px;
    right: 20px;
  }
}

.message-modal-default {
  .arco-modal-header {
    height: 40px;
    margin-top: 10px;
  }
}
</style>
